<script setup>
import youtubeIconW from "@/components/common/logo/youtubeIconW.vue";
import youtubeIconB from "@/components/common/logo/youtubeIconB.vue";
import facebookIconW from "@/components/common/logo/facebookIconW.vue";
import facebookIconB from "@/components/common/logo/facebookIconB.vue";
import twitterIconB from "@/components/common/logo/twitterIconB.vue";
import twitterIconW from "@/components/common/logo/twitterIconW.vue";
import informIcon from "@/components/common/logo/informIcon.vue";
import rightArrow from "@/components/common/logo/rightArrow.vue";
import keyInform from '@/components/modal/common/keyInformModal.vue';

import axios from "@/axios";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";

import {useLanguageStore} from "@/pinia";
import {useToast} from "@/composables/useToast";

const toast = useToast();
import {useRouter} from "vue-router";
const languageStore = useLanguageStore();
const title = computed(() => languageStore.get('snsConnectionManagement'))
const router = useRouter();

const iSelected = ref("");
const iShow = ref(false);
const selectedTab =  ref('tab1');
const temp = ref("temp");
const meta = ref("meta");
const twitter = ref("twitter");
const youtube =  ref("youtube");
const accessTokenValue = ref('');
const PageIdValue = ref(undefined);
const selectFileName = ref('');
const accessTokenItem = ref(undefined);
const accessTokenItem2 = ref(undefined);
const accessTokenItem3 = ref( undefined);
const keyValueIs = ref('');
const items = ref([]);
const inputValue = ref({
          pageId: '',
          accessToken: '',
          accessTokenSecret: '',
          apiKey: '',
          apiSecretKey: '',
          jsonFile: ''
        });
const emits = defineEmits([
    'set_title'
])

// OAuth 팝업 관련
const oauthWindow = ref(null)

// OAuth 인증 완료 메시지 리스너
const handleOAuthMessage = (event) => {
  const apiUrl = process.env.VUE_APP_API_URL || window.location.origin;
  if (event.origin !== apiUrl && event.origin !== window.location.origin) {
    return;
  }

  if (event.data && event.data.type === 'OAUTH_SUCCESS') {
    toast.success(languageStore.get('youtubeAuthSuccess'));
    if (oauthWindow.value && !oauthWindow.value.closed) {
      oauthWindow.value.close();
    }
    window.removeEventListener('message', handleOAuthMessage);
    // 페이지 새로고침하여 상태 업데이트
    window.location.reload();
  } else if (event.data && event.data.type === 'OAUTH_FAILURE') {
    toast.error(languageStore.get('youtubeAuthFailed') + ': ' + (event.data.message || ''));
    if (oauthWindow.value && !oauthWindow.value.closed) {
      oauthWindow.value.close();
    }
    window.removeEventListener('message', handleOAuthMessage);
  }
}

// 컴포넌트 언마운트 시 cleanup
onUnmounted(() => {
  if (oauthWindow.value && !oauthWindow.value.closed) {
    oauthWindow.value.close();
  }
  window.removeEventListener('message', handleOAuthMessage);
})

const resetKey = (dataSns) =>{
  if(dataSns === 'youtube') {
    selectFileName.value = '';
    this.$refs.fileInput.value = null;
  } else if(dataSns === 'meta') {
    inputValue.value.pageId = ''
    accessTokenValue.value = ''
  } else {
    inputValue.value.accessToken = ''
    inputValue.value.accessTokenSecret = ''
    inputValue.value.apiKey = ''
    inputValue.value.apiSecretKey = ''
  }
}


const iClick = (name) =>{
    iSelected.value = name;
    iShow.value = true;
}

//youtube
const selectFile = (event) =>{
    inputValue.value.jsonFile = event.target.files[0];
}

const submitYoutube = ()=> {
  if(!inputValue.value.jsonFile) {
    toast.warning(languageStore.get('selectFile'))
    return
  }

  // 팝업 차단 방지: 사용자 클릭 직후에 팝업을 먼저 열기
  const apiUrl = process.env.VUE_APP_API_URL || '';
  const width = 600;
  const height = 700;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  // 먼저 빈 팝업 열기 (사용자 제스처 직후이므로 차단되지 않음)
  oauthWindow.value = window.open(
    'about:blank',
    'YouTube OAuth',
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
  );

  // 팝업이 차단된 경우
  if (!oauthWindow.value || oauthWindow.value.closed) {
    toast.warning(languageStore.get('popupBlocked'));
    return;
  }

  // 로딩 메시지 표시
  oauthWindow.value.document.write(`<html><head><title>${languageStore.get('uploading')}</title></head><body style="display:flex;justify-content:center;align-items:center;height:100vh;font-family:sans-serif;"><h2>${languageStore.get('fileUploading')}</h2></body></html>`);

  const formData = new FormData();
  formData.append("file", inputValue.value.jsonFile);

  const options3 = {
    url: "/api/fileUpload",
    method: "POST",
    data: formData
  }

  axios(options3)
    .then(response => {
      toast.success(languageStore.get('registered'))

      // 메시지 리스너 등록
      window.addEventListener('message', handleOAuthMessage);

      // 팝업을 OAuth URL로 이동
      oauthWindow.value.location.href = apiUrl + '/oauth';
    }).catch(error => {
      console.log(error);
      toast.error(languageStore.get('fileUploadFailed'));
      // 업로드 실패 시 팝업 닫기
      if (oauthWindow.value && !oauthWindow.value.closed) {
        oauthWindow.value.close();
      }
    })

}

    //meta
const submitMeta = ()=>{
  if(!accessTokenValue.value || !inputValue.value.pageId) {
    toast.warning(languageStore.get('fillInBlank'))
    return;
  }


  const options = {
    url: '/api/meta',
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=UTF-8'
    },
    data: {  //순서 객체와 같아야함
      accessToken: accessTokenValue.value,
      pageId: inputValue.value.pageId
    }
  };


  axios(options)
    .then(response => {
      toast.success(languageStore.get('registered'));
      router.go(0)
      window.location.reload();
    })
    .catch(error => {
      console.log("Error:", error);
    });
}

    //twitter
const submitTwitter= ()=> {

  if (!inputValue.value.accessToken || !inputValue.value.accessTokenSecret || !inputValue.value.apiKey || !inputValue.value.apiSecretKey) {
    toast.warning(languageStore.get('fillInBlank'));
    return;
  }

  const options2 = {
    url: '/api/twitter',
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-type': 'application/json; charset=UTF-8'
    },
    data: {
      accessToken: inputValue.value.accessToken,
      accessTokenSecret: inputValue.value.accessTokenSecret,
      apiKey: inputValue.value.apiKey,
      apiSecretKey: inputValue.value.apiSecretKey
    }
  }

  axios(options2)
    .then(response => {
      toast.success(languageStore.get('registered'))
      window.location.reload();

    }).catch(error => {
      console.log(error)
    })
}

const deleteKey = (dataSns)=> {
  if(confirm( dataSns + languageStore.get('deleteKeyConfirm'))) {
    if(dataSns === 'youtube') {
      keyValueIs.value = selectFileName.value
    } else {
      keyValueIs.value = temp.value
    }
      axios.delete("/api/deleteKey", {
          params : {
              sns: dataSns,
              keyValue: keyValueIs.value
          }
      })
      .then(response => {
              //alert("삭제되었습니다.");
              console.log(response);
              window.location.reload();
          })
      .catch(error => console.log(error))
  }

}
const getMetaData = ()=>{
  axios.get('/api/meta')
      .then(response => {
        items.value = response.data;
        accessTokenItem.value = items.value.find(item => item.keyName === "accessToken"); //.find 배열에서 조건을 만족하는 첫번째 요소
        const PageIdItem = items.value.find(item => item.keyName === "pageId");
        if(PageIdItem) {
          accessTokenValue.value = accessTokenItem.value.keyValue;
          PageIdValue.value = PageIdItem.keyValue;

        }
      }).catch(error => {
        console.log(error)
      })
}

const getTwitterData = ()=>{
  axios.get("/api/twitter/key")
      .then(response => {
        items.value = response.data;
        accessTokenItem2.value = items.value.find(item => item.keyName === 'apiKey');
        inputValue.value.apiKey = items.value.find(item => item.keyName === "apiKey").keyValue;
        inputValue.value.apiSecretKey = items.value.find(item => item.keyName === "apiSecretKey").keyValue;
        inputValue.value.accessTokenSecret = items.value.find(item => item.keyName === "accessTokenSecret").keyValue;
        inputValue.value.accessToken = items.value.find(item => item.keyName === "accessToken").keyValue;
      })
      .catch(error => {
        console.log(error)
      })

}

const getYoutubeData = ()=>{
  axios.get("/api/youtube")
      .then(response => {
        items.value = response.data;
        accessTokenItem3.value = items.value.find(item => item.keyName === 'jsonKey')
        selectFileName.value = response.data[0].keyValue;
      })
      .catch(error => {
        console.log(error);
      })

}

onMounted( ()=>{
    getYoutubeData();
    getMetaData();
    getTwitterData();
    emits('set_title', title.value)
});
watch(title, (v) => emits('set_title', v))

</script>

<template>
  <v-snackbar v-model="toast.show.value" :color="toast.color.value" :timeout="toast.timeout.value" location="top">
    {{ toast.message.value }}
    <template v-slot:actions>
      <v-btn variant="text" @click="toast.close()">{{ languageStore.get('close') }}</v-btn>
    </template>
  </v-snackbar>
  <div class="contentArea">
    <div class="contentWrapper">
      <div class="tabContent">
        <div class="tabs">
          <div class="tab" :class="{ active : selectedTab === 'tab1'}" @click="selectedTab = 'tab1'">
            <template v-if="selectedTab === 'tab1'"><youtube-icon-b class="icons"></youtube-icon-b><span class="iconsText">Youtube</span><right-arrow class="rightArrow"></right-arrow></template>
            <template v-else><youtube-icon-w class="icons"></youtube-icon-w> <span class="iconsText">Youtube</span></template>
          </div>

<!--          <div class="tab" :class="{ active : selectedTab === 'tab2'}" @click="selectedTab = 'tab2'">
            <template v-if="selectedTab === 'tab2'"><facebook-icon-b class="icons"></facebook-icon-b><span class="iconsText">Facebook</span><right-arrow class="rightArrow"></right-arrow></template>
            <template v-else><facebook-icon-w class="icons"></facebook-icon-w><span class="iconsText">Facebook</span></template>
          </div>
          <div class="tab" :class="{ active : selectedTab === 'tab3'}" @click="selectedTab = 'tab3'">
            <template v-if="selectedTab === 'tab3'"><twitter-icon-b class="icons"></twitter-icon-b><span class="iconsText">Twitter</span><right-arrow class="rightArrow"></right-arrow></template>
              <template v-else><twitter-icon-w class="icons"></twitter-icon-w><span class="iconsText">Twitter</span></template>
          </div>-->
        </div>
        <div class="tabTab" v-if="selectedTab === 'tab1'">
          <div class="apiTop">
            <div class="title">Youtube Api Key</div>
            <inform-icon @click="iClick('youtube')" class="infoIcon"></inform-icon>
          </div>
          <div class="apiArea">
            <div class="apiNm">Json File</div>
            <input v-if="accessTokenItem3 === undefined" id="file" type="file" name="file" ref="fileInput" @change="selectFile"/>
            <textarea v-else v-model="selectFileName" class="textArea3"></textarea>
          </div>
          <div class="btns">
            <v-btn
                v-if="accessTokenItem3 === undefined"
                color="#052C65"
                @click="submitYoutube"
            >{{languageStore.get('register')}}</v-btn>
            <v-btn
                v-if="accessTokenItem3 !== undefined"
                base-color="red"
                @click="deleteKey('youtube')"
            >{{languageStore.get('delete')}}</v-btn>
            <v-btn
                v-else
                @click="resetKey('youtube')"
            >{{languageStore.get('reenter')}}</v-btn>
          </div>
        </div>
        <div class="tabTab" v-else-if="selectedTab === 'tab2'">
          <div class="apiTop">
          <div class="title">Facebook Api Key</div>
            <inform-icon @click="iClick('meta')" class="infoIcon" ></inform-icon>
          </div>
          <div class="apiArea">
          <div class="apiNm">API Key</div>
            <textarea v-if="PageIdValue !== undefined" v-model="accessTokenValue" class="textArea5" readonly></textarea>
            <textarea v-else v-model="accessTokenValue" :placeholder="languageStore.get('pleaseEnter')"></textarea>
          </div>
          <div class="apiArea">
          <div class="apiNm">Group ID</div>
            <textarea v-if="PageIdValue !== undefined" v-model="PageIdValue" class="textArea4" readonly></textarea>
            <textarea v-else v-model="inputValue.pageId" :placeholder="languageStore.get('pleaseEnter')"></textarea>
          </div>
          <div class="btns">
            <v-btn
                v-if="PageIdValue === undefined"
                color="#052C65"
                @click="submitMeta"
            >{{languageStore.get('register')}}</v-btn>
            <v-btn
                v-if="PageIdValue !== undefined"
                base-color="red"
                @click="deleteKey('meta')"
            >{{languageStore.get('delete')}}</v-btn>
            <v-btn
                v-else
                @click="resetKey('meta')"
            >{{languageStore.get('reenter')}}</v-btn>
          </div>
        </div>
        <div class="tabTab" v-else-if="selectedTab === 'tab3'">
          <div class="apiTop">
          <div class="title">Twitter Api Key</div>
          <inform-icon @click="iClick('twitter')" class="infoIcon"></inform-icon>
        </div>

        <div class="apiArea2">
          <div class="apiNm">Access Token</div>
          <textarea v-if="accessTokenItem2 !== undefined" v-model="inputValue.accessToken" readonly></textarea>
          <textarea v-else v-model="inputValue.accessToken" :placeholder="languageStore.get('pleaseEnter')"></textarea>
        </div>

        <div class="apiArea2">
          <div class="apiNm">Access Token Secret</div>
          <textarea v-if="accessTokenItem2 !== undefined" v-model="inputValue.accessTokenSecret" readonly></textarea>
          <textarea v-else v-model="inputValue.accessTokenSecret" :placeholder="languageStore.get('pleaseEnter')"></textarea>
        </div>

        <div class="apiArea2">
          <div class="apiNm">API Key</div>
          <textarea v-if="accessTokenItem2 !== undefined" v-model="inputValue.apiKey" class="textArea2" readonly></textarea>
          <textarea v-else v-model="inputValue.apiKey" :placeholder="languageStore.get('pleaseEnter')"></textarea>
        </div>

        <div class="apiArea2">
          <div class="apiNm">API Secret Key</div>
          <textarea v-if="accessTokenItem2 !== undefined" v-model="inputValue.apiSecretKey" class="textArea2" readonly></textarea>
          <textarea v-else v-model="inputValue.apiSecretKey" :placeholder="languageStore.get('pleaseEnter')"></textarea>
        </div>

        <div class="btns">
          <v-btn
              v-if="accessTokenItem2 === undefined"
              color="#052C65"
              @click="submitTwitter"
          >{{languageStore.get('register')}}</v-btn>
          <v-btn
              v-if="accessTokenItem2 !== undefined"
              base-color="red"
              @click="deleteKey('twitter')"
          >{{languageStore.get('delete')}}</v-btn>
          <v-btn
              v-else
              @click="resetKey('twitter')"
          >{{languageStore.get('reenter')}}</v-btn>

        </div>
      </div>
    </div>
  </div>
</div>

<key-inform v-if="iShow" @close="iShow = false" :dataSnsNm="iSelected"></key-inform>
</template>

<style lang="css" scoped>

.infoIcon{
  position: absolute;
  left: 95%;  
  cursor: pointer;
}

.iconsText{
  position: fixed;
  left: 16%;
}

.icons {
  position: fixed;
  left: 12.5%;
  /* background-color: red; */
}

.deleteBtn {
  background-color: #808695 !important;
  position: fixed;
  left: 51%;
  bottom: 7%;
}

.reBtn{
  background-color: #808695 !important;
}

.btns {
  position: fixed;
  left: 48%;
  bottom: 10%;
  margin:10px;
  min-width: 200px;
  display: flex;
  justify-content: space-evenly;
}
.btns button{
  white-space: nowrap;
  padding: 0 12px;
}


.tabTab{
  position: relative;
  left: 20%;
  background-color: #F6F9FF;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(36, 61, 108, 0.3);
}

.rightArrow {
  position: fixed;
  left: 21%;
  align-items: center;
}

.apiTop{
  display: flex;
}

textarea {
    width: 38vw; 
    height: 5vh;
    padding: 10px 15px; 
    border: none;
    border-radius: 4px;
    font-size: 16px; 
    font-family: Arial, sans-serif;
    resize: vertical;
    margin: 15px 15px 15px 0;
    line-height: 1.4;
}

textarea:focus {
    border-color: #66afe9; 
    outline: none; 
    box-shadow: 0 0 8px rgba(102, 175, 233, 0.6); 
}

.apiNm{
  color: #536471;
  font-weight: bold;
}

.title {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 20px;
}

.tabContent{
  display: flex;
}

.tab {
  padding: 35px 24px 35px 35px;
  cursor: pointer;
  border-right: 3px solid #ccc;
  font-size: 17px;
  background-color: #243d6c;
  border: 1px solid #ebebeb;
  margin: 2.5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  text-align: center;
  height: 8vh;
}

.tab.active {
  background-color: #ffffff; 
  color: #243d6c;
  font-weight: bold;
  border-bottom: 5px solid #243d6c;
}

.tabs {
  width: 14vw;
  position: fixed;
  left: 10%;
  bottom: 45%;
}

textarea {
  resize: none;
}

.contentArea {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85%;
}

.contentWrapper {
  border-radius: 10px;
  width: 60vw;
  padding-right: 150px;
  height: 80vh;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.apiArea {
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 40vw;
  height: 13vh;
  background-color: white;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid rgba(36, 61, 108, 0.3);
}

.apiArea2 {
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 40vw;
  height: 11vh;
  background-color: white;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid rgba(36, 61, 108, 0.3);
}

.apiArea2 textarea {
  height: 5vh;
  margin-top: 10px;
}

input[type=file]::file-selector-button {
  margin: 10px 10px 20px 15px;
  width: 90px;
  height: 30px;
  background: #fff;
  border: 1px solid rgb(77,77,77);
  border-radius: 2px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

input[type=file]::file-selector-button:hover {
  background: rgb(77,77,77);
  color: #fff;
}

#file {
  position: relative;
  left: 30%;
  top: 10%;
}
</style>